module.exports = __webpack_public_path__ + "media/images/smart_phone/icons/my_page-9f3c73e5b9ce5bb91e024d26db611f1a.png";